import * as THREE from 'three';
import HeatMap from './heat-map';
import { cancelIdleCallback, requestIdleCallback } from '../../utils/index';
import { mergeBufferGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils';
import { isArray } from 'lodash';
class HeatMaps extends THREE.Group {
    props;
    needDeep;
    timer;
    constructor(data) {
        super();
        const { list, renderProps, zIndex } = data;
        const { mode } = renderProps;
        // this.position.z = zIndex;
        this.props = data;
        this.needDeep = false;
        this.timer = -1;
        this.name = this.uuid;
        this.addPojects(list, mode);
    }
    addPojects(list, mode) {
        cancelIdleCallback(this.timer);
        const geometryMap = {
            normal: [],
            critical: [],
            major: [],
            minor: [],
            complex: [],
        };
        const materialMap = {
            normal: null,
            critical: null,
            major: null,
            minor: null,
            complex: null,
        };
        const geometeryList = [];
        const materialList = [];
        let currentIndex = 0;
        const workLoop = (deadline) => {
            let shouldYield = false;
            const index = currentIndex;
            while (currentIndex < list.length && !shouldYield) {
                const item = list[currentIndex];
                const mesh = new HeatMap(item);
                mesh.updateWorldMatrix(true, false);
                const geometry = mesh.geometry.clone().applyMatrix4(mesh.matrixWorld);
                geometeryList.push(geometry);
                materialList.push(mesh.material);
                // mesh.updateMatrix();
                // geometryMap[item.renderProps.type as 'normal' | 'critical' | 'major' | 'minor'].merge(
                //   mesh.geometry as unknown as Geometry,
                //   mesh.matrix
                // );
                // (materialMap[item.renderProps.type as 'normal'] as any) = mesh.material;
                // mesh.dispose();
                currentIndex++;
                shouldYield = deadline ? deadline.timeRemaining() < 1 : true;
            }
            // console.log(`本次执行${currentIndex - index}次操作`);
            if (currentIndex < list.length) {
                this.timer = requestIdleCallback(workLoop);
            }
            else {
                this.traverse((mesh) => {
                    if (mesh instanceof THREE.Mesh) {
                        mesh?.geometry?.dispose();
                        // mesh.material?.map?.dispose();
                        if (isArray(mesh?.material)) {
                            mesh?.material.map((item) => item?.dispose());
                        }
                        else {
                            mesh?.material?.dispose();
                        }
                        // mesh?.parent?.remove(mesh);
                    }
                });
                this.remove(...this.children);
                if (geometeryList.length > 0) {
                    const merged = mergeBufferGeometries(geometeryList, true);
                    this.add(new THREE.Mesh(merged, materialList));
                }
                // for (const key in materialMap) {
                //   if (materialMap[key as 'normal' | 'critical' | 'major' | 'minor']) {
                //     this.add(
                //       new THREE.Mesh(
                //         geometryMap[key as 'normal' | 'critical' | 'major' | 'minor'] as any,
                //         materialMap[key as 'normal' | 'critical' | 'major' | 'minor'] as any
                //       )
                //     );
                //   }
                // }
            }
        };
        this.timer = requestIdleCallback(workLoop);
    }
    update(data) {
        const { list, renderProps } = data;
        const { mode } = renderProps;
        if (list !== this.props.list) {
            // this.remove(...this.children);
            this.addPojects(list, mode);
            // setTimeout(() => {
            //   this.traverse((mesh) => {
            //     if (mesh instanceof THREE.Mesh) {
            //       (mesh as THREE.Mesh).geometry.dispose();
            //       ((mesh as THREE.Mesh).material as any).dispose();
            //     // mesh?.parent?.remove(mesh);
            //     }
            //   });
            //   this.remove(...this.children);
            //   this.addPojects(list);
            // }, 0);
        }
        this.props = data;
    }
    dispose() {
        cancelIdleCallback(this.timer);
        this.traverse(function (obj) {
            if (obj instanceof THREE.Mesh) {
                obj.geometry?.dispose();
                obj.material?.dispose();
            }
            else {
                if (obj.parent) {
                    obj?.parent.remove(obj);
                }
                obj.clear();
            }
        });
        this.parent?.remove(this);
        this.clear();
    }
}
export default HeatMaps;
